import { render, staticRenderFns } from "./calculo.ped.vue?vue&type=template&id=734122fa&scoped=true&"
import script from "./calculo.ped.vue?vue&type=script&lang=js&"
export * from "./calculo.ped.vue?vue&type=script&lang=js&"
import style0 from "./calculo.ped.vue?vue&type=style&index=0&id=734122fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734122fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VSpacer})
